(function() {
	'use strict';

	angular.module('app.core')
		.service('watcherFunctionsService', watcherFunctionsService);

	watcherFunctionsService.$inject = ['$timeout'];
	function watcherFunctionsService($timeout) {
		return {
			getUsersForTagging: getUsersForTagging,
			formatTagResult: formatTagResult,
			getWatchersIfAny: getWatchersIfAny
		};

		function getUsersForTagging(val, watcherObject, users) {
			// Get cursor position
			var selectionStart = document.activeElement.selectionStart;
			var selectionEnd = document.activeElement.selectionEnd;
			// Text is highlighted
			if (selectionStart !== selectionEnd) {
				watcherObject.displayNoUsersFound = false;
				return [];
			}
			var searchString = val.substring(0, selectionStart);
			watcherObject.suffixForTagging = val.substring(selectionStart);
			var idPosition = searchString.lastIndexOf('@');
			var lastCloseBracket = searchString.lastIndexOf(']');
	
			if (idPosition < 0 || idPosition === searchString.length - 1
				|| (idPosition > 0 && searchString[idPosition - 1] !== ' ' && searchString[idPosition - 1] !== '[')
				|| idPosition < lastCloseBracket) {
				watcherObject.displayNoUsersFound = false;
				return [];
			}
	
			watcherObject.prefixForTagging = searchString.substr(0, idPosition);
			var search = searchString.substring(idPosition + 1);
	
			//Stop looking after 3 spaces
			var spaceCount = search.split(' ').length - 1;
			if (spaceCount >= 3) {
				watcherObject.displayNoUsersFound = false;
				return [];
			}
	
			var userList = findInUsers(search, users);
			if (userList && userList.length) {
				watcherObject.displayNoUsersFound = false;
			} else {
				watcherObject.displayNoUsersFound = true;
			}
			return userList;
		}

		function findInUsers(search, users) {
			var tokens = search.split(' ');
			var tokenLength = tokens.length;
			var userListLength = users.length;
			if (!tokenLength || !userListLength) {
				return [];
			}
			var results = [];
			var user, token, isMatched, partialMatch;
			for (var i = 0; i < userListLength; i++) {
				isMatched = true;
				user = users[i];
				if (user.state !== 'active') {
					continue;
				}
				for (var j = 0; j < tokenLength; j++) {
					token = tokens[j].toUpperCase();
					partialMatch = false;
					if (user.firstName.toUpperCase().indexOf(token) >= 0
						|| user.lastName.toUpperCase().indexOf(token) >= 0
						|| user.emailAddress.toUpperCase().indexOf(token) >= 0) {
						partialMatch = true;
					}
					if (!partialMatch) {
						isMatched = false;
						break;
					}
				}
				if (isMatched) {
					results.push(user);
					if (results.length === 5) {
						break;
					}
				}
			}
			return results;
		}

		function formatTagResult(model, task, watcherObject, isNewTask, key) {
			if (!model) {
				return watcherObject.prefixForTagging + watcherObject.suffixForTagging;
			}
			if (typeof model === 'string') {
				return model;
			}
			var display = '@';
			if (watcherObject.emailSuffix) {
				var emailSplit = model.emailAddress.split('@');
				display += emailSplit[0];
				if (emailSplit[1] !== watcherObject.emailSuffix) {
					display += '(' + emailSplit[1] + ')';
				}
			}
			addTempWatcher(isNewTask ? -1 : task.id, model.ndx, display, watcherObject);
			$timeout(function() {
				var cursor = (watcherObject.prefixForTagging + '[' + display + '] ').length;
				document.activeElement.selectionStart = cursor;
				document.activeElement.selectionEnd = cursor;
			});
			task[key] = watcherObject.prefixForTagging + '[' + display + ']' + watcherObject.suffixForTagging;
			return watcherObject.prefixForTagging + '[' + display + ']' + watcherObject.suffixForTagging;
		}

		function addTempWatcher(taskId, userNdx, tag, watcherObject) {
			if (!watcherObject.tempWatchers[taskId]) {
				watcherObject.tempWatchers[taskId] = {};
			}
			watcherObject.tempWatchers[taskId][userNdx] = tag;
		}

		function getWatchersIfAny(taskId, text, watcherObject) {
			var returnList = [];
			var tempWatchersObject = watcherObject.tempWatchers[taskId];
			for (var userNdx in tempWatchersObject) {
				var tag = tempWatchersObject[userNdx];
				if (text.indexOf(tag) >= 0 && !_.find(returnList, {userNdx: userNdx})) {
					returnList.push({'userNdx': userNdx, 'actionNdx': -1});
				}
			}
			return returnList;
		}
	}
})();
